<template>
    <div>
        <breadcrumb :routerList="[{title:'完成代办任务'}]"/>
        <div class="h-piece">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="f" label-position="right" :rules="rules" ref="formLabelAlign" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="审批意见" class="h-elformWrap-2" prop="name">
                                <el-input v-model="f.yijian"></el-input>
                            </el-form-item>
                            <el-form-item class="h-elformWrap-1">
                                <el-button @click="bohuitongguo(1)" class="h-btn h-formBtn h-bgred">驳回</el-button>
                                <el-button @click="bohuitongguo(2)" class="h-btn h-formBtn h-bggreen">通过</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                f: {
                    name: '',
                    contact: '',
                    contactInfo: '',
                    type: '',
                    date3: '',
                    explain: ''
                },
                urlparams: {
                    taskid:null,
                    ywid:null,
                    instid:null,
                }
            }
        },
        created() {
            this.urlparams = this.$route.query
        },
        methods: {
            bohuitongguo(flag) {
                ss.taskservice.complete({taskid: this.urlparams.taskid, optflag: flag,yijian:this.f.yijian}).then(rd => {
                    this.$msg.msgs(JSON.stringify(rd));
                    this.$router.go(0)
                })
            },
        }
    }
</script>
<style>

</style>
